import {
  KPIS_AC_LOADING, KPIS_AC_OBTENIDO, KPIS_AC_ERROR, KPIS_AC_PRODS_OK, KPIS_AC_DOCENTES_OK,
} from '../actions/kpisAcademicosActions';

const initialState = {
  loading:   false,
  datos:     null,
  productos: [],
  docentes:  [],
};

export default function kpisAcademicosReducer(state = initialState, action) {
  switch (action.type) {
    case KPIS_AC_LOADING:
      return { ...state, loading: true };
    case KPIS_AC_OBTENIDO:
      return { ...state, loading: false, datos: action.payload };
    case KPIS_AC_ERROR:
      return { ...state, loading: false };
    case KPIS_AC_PRODS_OK:
      return { ...state, productos: action.payload };
    case KPIS_AC_DOCENTES_OK:
      return { ...state, docentes: action.payload };
    default:
      return state;
  }
}
